import { Text } from '@spothero/ui';
import React from 'react';
function Header() {
    return (<Text fontWeight="semibold" fontSize="md" borderBottom="1px solid gray" borderBottomColor="gray.200" paddingBottom={2} paddingLeft={{ base: 4, tablet: 12 }} marginX={{ base: '-16px', tablet: '-48px' }} marginTop={{ tablet: '-16px' }} marginBottom={{ tablet: 2 }}>
            Price Breakdown
        </Text>);
}
export default Header;
